import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Industries', path: '/services#industries' },
    { name: 'Approach', path: '/#approach' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/81550871-f738-4005-8be0-776988e2bbe6.png"
              alt="IRS Ventures LLC"
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.path}
                className={`text-sm font-medium tracking-wide transition-all duration-200 relative group ${
                  isScrolled ? 'text-navy-primary' : 'text-white'
                } hover:text-gold`}
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gold transition-all duration-200 group-hover:w-full"></span>
              </a>
            ))}
          </div>

          <Link
            to="/contact"
            className={`hidden md:block px-8 py-2.5 text-sm font-medium border border-gold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'text-gold hover:bg-gold hover:text-navy-primary'
                : 'text-gold hover:bg-gold hover:text-navy-primary'
            }`}
          >
            Request Strategy Call
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;